/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdChatLoadingProps } from './type';
const props: TdChatLoadingProps = {
  /** 加载的状态形式 */
  animation: {
    type: String,
    value: 'moving',
  },
  /** 加载过程展示的文字内容 */
  text: {
    type: String,
    value: '',
  },
};

export default props;
